module.exports = __webpack_public_path__ + "static/media/home-icon.34c894da.svg";